import Events from '../_utils/events.js';


class AppEvents extends Events {

}

let appEventsService = new AppEvents();

export default appEventsService;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_services/app-events.service.js